import { useState } from "react";

const options = [
  {
    id: "basic",
    title: "Basic Essentials",
    subtitle: "Phones, Wi-Fi, laptop, TV, USB devices",
    recommendation: "We\u2019d suggest: A compact backup system",
    icon: "ri-smartphone-line",
    capacity: "500W–2kWh",
    color: "border-gray-200",
    selectedColor: "border-amber-400 bg-amber-50",
  },
  {
    id: "home",
    title: "Home Essentials",
    subtitle: "Refrigerator, sump pump, lights, charging, internet",
    recommendation: "We\u2019d suggest: A mid-range solar generator system",
    icon: "ri-home-line",
    capacity: "2kWh–5kWh",
    color: "border-gray-200",
    selectedColor: "border-amber-400 bg-amber-50",
    popular: true,
  },
  {
    id: "heavy",
    title: "Heavy-Duty Backup",
    subtitle: "HVAC, washer, well pump, EV charger, appliances",
    recommendation: "We\u2019d suggest: A whole-home expandable system",
    icon: "ri-flashlight-line",
    capacity: "10kWh+",
    color: "border-gray-200",
    selectedColor: "border-amber-400 bg-amber-50",
  },
];

export default function PowerCalculator() {
  const [selected, setSelected] = useState<string>("home");
  const current = options.find((o) => o.id === selected)!;

  return (
    <section id="calculator" className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900">
            Quick Home Backup Power Calculator
          </h2>
          <p className="text-gray-500 mt-3 max-w-xl mx-auto text-base">
            Use this tool to estimate what kind of system you may need based on what you want to keep running during an outage.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {options.map((opt) => (
            <button
              key={opt.id}
              onClick={() => setSelected(opt.id)}
              className={`relative flex flex-col items-start text-left p-6 rounded-lg border-2 transition-all cursor-pointer ${
                selected === opt.id ? opt.selectedColor : opt.color + " hover:border-gray-300"
              }`}
            >
              {opt.popular && (
                <span className="absolute top-3 right-3 text-[10px] bg-amber-500 text-white px-2 py-0.5 rounded-full font-semibold">
                  Most Common
                </span>
              )}
              <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full mb-3">
                <i className={`${opt.icon} text-xl text-gray-700`}></i>
              </div>
              <p className="font-bold text-gray-900 text-base mb-1">{opt.title}</p>
              <p className="text-gray-500 text-xs leading-relaxed mb-3">{opt.subtitle}</p>
              <span className="text-xs font-semibold text-amber-600 bg-amber-50 border border-amber-200 px-2 py-1 rounded">{opt.capacity}</span>
            </button>
          ))}
        </div>

        {/* Result */}
        <div className="mt-8 bg-gray-950 text-white rounded-lg p-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div>
            <p className="text-xs text-gray-400 uppercase tracking-widest mb-1">Recommended For You</p>
            <p className="text-lg font-bold text-amber-400">{current.recommendation}</p>
            <p className="text-gray-400 text-sm mt-1">{current.subtitle}</p>
          </div>
          <a
            href="#"
            className="shrink-0 bg-amber-500 hover:bg-amber-400 text-white font-bold px-6 py-3 rounded-md transition-colors cursor-pointer whitespace-nowrap text-sm"
          >
            Shop {current.title} Systems
          </a>
        </div>

        <p className="text-center text-gray-400 text-xs mt-4">
          Not sure what system you need? <a href="#" className="text-amber-500 hover:underline cursor-pointer">Chat with our most recommended setup for homeowners.</a>
        </p>
      </div>
    </section>
  );
}
